
    import I18n from 'i18nObj';
    
      import 'translations/handlebars_helpers';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('handlebars_helpers');
  